import { useState } from "react";
import ReactPaginate from "react-paginate";
import LoadingSpinner from "../../loader/Loader";
import { useGetActivitiesQuery } from "../../../features/api/activityApiSlice";
import { useVideo } from "../../../hooks/useVideo";

const ActivityLog = () => {
  const { formatDate } = useVideo();
  const [currentPage, setCurrentPage] = useState(0);
  const itemsPerPage = 5;

  const { data: activities, isLoading, isError } = useGetActivitiesQuery();

  const renderVideoList = () => {
    // Pagination Logic
    const pageCount = Math.ceil(activities?.length / itemsPerPage);
    const filteredActivities = activities?.slice(
      currentPage * itemsPerPage,
      (currentPage + 1) * itemsPerPage
    );

    if (isLoading) return <LoadingSpinner />;

    if (!activities || activities?.length === 0) {
      return (
        <div className="no-content">
          <div>
            <p>No activities found</p>
          </div>
        </div>
      );
    } else if (isError)
      return (
        <div className="no-content">
          <div>
            <p>Error loading activities</p>
          </div>
        </div>
      );

    return (
      <div className="dashboard-wrapper">
        <div className="dashboard-top-section">
          <div className="dash-top-flex">
            <h1 className="dashboard-title">Activity Log</h1>
          </div>
        </div>
        <div className="recent-activity">
          {filteredActivities?.map((activity) => (
            <div key={activity?._id} className="activity-item">
              <p style={{ fontWeight: "500" }}>{activity?.type}</p>
              <p>{activity?.details}</p>
              <span>{formatDate(activity?.timestamp)}</span>
            </div>
          ))}
        </div>
        <ReactPaginate
          previousLabel={"Previous"}
          nextLabel={"Next"}
          breakLabel={"..."}
          pageCount={pageCount}
          marginPagesDisplayed={2}
          pageRangeDisplayed={5}
          onPageChange={({ selected }) => setCurrentPage(selected)} // Update current page on change
          containerClassName={"pagination"}
          pageClassName={"pagination-page"}
          pageLinkClassName={"page-link"}
          previousClassName={"pagination-previous"}
          nextClassName={"pagination-next"}
          activeClassName={"active-btn"} // Set the active class here
          renderOnZeroPageCount={null}
        />
      </div>
    );
  };

  return renderVideoList();
};

export default ActivityLog;
